import { useAppSelector } from 'redux/hooks'
import { useFolderDrag, useFolderDrop } from 'components/folderPage/folderHooks'

import { selectIsFolderMultiSelected, selectTotalMultiSelectedSize } from 'redux/folders/selectors'

import Icon from 'components/elements/Icon'
import Link from 'components/elements/Link'
import Checkbox from 'components/formElements/Checkbox'
import FolderOptions from 'components/folderPage/FolderOptions'

import { SubfolderFolderItemType } from 'types/folders'

import styles from './folderGridItem.module.scss'

type Props = {
  folder: SubfolderFolderItemType
  onToggleSelected?: () => void
  notSelectable?: boolean
}

const FolderGridItem = ({ folder, onToggleSelected, notSelectable }: Props) => {
  const selected = useAppSelector(selectIsFolderMultiSelected(folder.id))
  const totalSelected = useAppSelector(selectTotalMultiSelectedSize)

  const [_collector, drag] = useFolderDrag(folder, selected, totalSelected)
  const [{ isOver }, drop] = useFolderDrop(folder)

  return drop(
    <div className={styles.container}>
      <Link
        className={`${styles.folder} ${isOver ? styles.isOver : ''}`}
        key={folder.id}
        href={`/folders/${folder.id}/`}>
        <Icon name={!folder.createdAt ? 'level up' : 'folder'} />
        <span className={styles.folderName}>
          {folder.private && <Icon name="lock" />}
          {folder.name}
        </span>
      </Link>

      {selected && (
        <div className={styles.selected} onClick={onToggleSelected}>
          <Icon name="check" />
        </div>
      )}

      {!notSelectable && (
        <>
          <div className={styles.extras}>
            {drag(
              <div className={styles.dragHandle}>
                <Icon name="bars" />
              </div>,
            )}

            <Checkbox checked={selected} onChange={onToggleSelected} />
          </div>

          <div className={styles.bottomExtras}>
            <FolderOptions folder={folder} />
          </div>
        </>
      )}
    </div>,
  )
}

export default FolderGridItem
